import { withInstall } from './utils'
import Watermark from './src/watermarkcomp.vue'
import type { SFCWithInstall } from './utils'

export const ElWatermark: SFCWithInstall<typeof Watermark> = withInstall(Watermark)
export default ElWatermark

export * from './src/watermark'
